import Api from '../../../shared/Api';

export default class PhotographerCalendarApi {
    static getPhotographerCalendars(
        year: number,
        month: number,
        day: number,
        address: string,
        postalCode: string,
        city: string,
        addressPointLocationLongitude: number,
        addressPointLocationLatitude: number,
        executionTime: number,
        productNames: string[],
        productIds: number[],
        brokerFirmRegionId: number,
        brokerFirmId: number,
        orderId?: number,
        numberOfMeasuredPlans?: number
    ) {
        return new Api().get(`/views/photographer-booking/scandphotos`, {
            year: year,
            month: month,
            day: day,
            address: encodeURI(address),
            postalCode: encodeURI(postalCode),
            city: encodeURI(city),
            executionTime: executionTime,
            brokerFirmRegionId: brokerFirmRegionId,
            brokerFirmId: brokerFirmId,
            productNames: productNames,
            productIds: productIds,
            addressPointLocationLongitude: addressPointLocationLongitude,
            numberOfMeasuredPlans: numberOfMeasuredPlans,
            addressPointLocationLatitude: addressPointLocationLatitude,
            orderId: orderId
        });
    }

    static getOrderInfo(orderId: number) {
        return new Api().get('/views/photographer-booking/scandphotos/order-info', {
            orderId: orderId
        });
    }

    static updatePhotographerCalendar(data: any) {
        return new Api().put(`/views/photographer-booking`, data);
    }
}
